class GiftSelector {
    constructor() {
      this.currentGifts = [];
      this.totalChoosableQuantity = 0
    }

    addGift(gift) {
      this.currentGifts.push(gift);
    }
    removeGift(gift) {
      const currentProductIndex = this.currentGifts.findIndex(g => g.id === gift.id);
      if (currentProductIndex !== -1) {
          this.currentGifts.splice(currentProductIndex, 1);
      }
    }

    getTotalChoosableQuantity(){
      return this.totalChoosableQuantity;
    }

    setTotalChoosableQuantity(total){
      this.totalChoosableQuantity = total
    }

    getCurrentGiftList(){
      return this.currentGifts;
    }

    getCurrentGiftQuantity(){
      let validQuantity = 0;
      this.currentGifts.forEach(gift => {
        if(!gift?.noValidate){
          validQuantity +=1
        }
      });
      return validQuantity;
    }
  }
  const giftSelector = new GiftSelector();

  function updateGiftSelector(gift, type, noValidate = false){
    switch(type){
      case 'plus':
      let giftData = gift
      if(noValidate) giftData = {...giftData, noValidate}
      giftSelector.addGift(giftData);
      break;
      case 'minus':
      giftSelector.removeGift(gift);
      break;
    }
  }

  function updateTotalChoosableQuantity(quantity) {
    giftSelector.setTotalChoosableQuantity(quantity)
  }

  function clearSelectedGifts(){
    giftSelector.currentGifts =  [];
  }